import { React, useEffect, useState } from "react";

function Order_payment_method({ options = [], handleChangeData }) {
  // useEffect(() => {
  //   document.querySelectorAll(".payment-label").forEach((eachLabelElem) =>
  //     eachLabelElem.addEventListener("click", function (elm) {
  //       var pr = document.querySelectorAll(".method");
  //       [].forEach.call(pr, function (el) {
  //         el.classList.remove("active");
  //       });
  //       const parent = elm.target.closest(".method");
  //       parent.classList.add("active");
  //     })
  //   );
  // }, []);

  const [value, setValue] = useState(null);

  const handleChange = (value) => {
    setValue(value);
    handleChangeData({ payment_method: value });
  };

  return (
    <div className="form-item payment-methods">
      <div className="right">
        <label htmlFor="order_payment_method">
          <i className="far fa-credit-card"></i>
          روش پرداخت
        </label>
      </div>
      <div className="left">
        {options.map((option, index) => (
          <div
            key={index}
            className={
              value === option.unique_name ? "method active" : "method"
            }
            onClick={() => {
              handleChange(option.unique_name);
            }}
          >
            <input
              type="radio"
              name="order_payment_method"
              id="payment-card"
              value={option.unique_name}
            />
            <label htmlFor="payment-card" className="payment-label">
              <i className="fas fa-credit-card"></i>
              <p className="method-name">{option.title}</p>
            </label>
          </div>
        ))}
        {/* <div className="method">
          <input
            type="radio"
            name="order_payment_method"
            id="payment-card"
            value="card"
          />
          <label htmlFor="payment-card" className="payment-label">
            <i className="fas fa-credit-card"></i>
            <p className="method-name">آنلاین</p>
          </label>
        </div>
        <div className="method">
          <input
            type="radio"
            name="order_payment_method"
            id="payment-cash"
            value="cash"
          />
          <label htmlFor="payment-cash" className="payment-label">
            <i className="fas fa-wallet"></i>
            <p className="method-name">پول نقد</p>
          </label>
        </div>
        <div className="method">
          <input
            type="radio"
            name="order_payment_method"
            id="payment-pose"
            value="pose"
          />
          <label htmlFor="payment-pose" className="payment-label">
            <i className="fas fa-cash-register"></i>
            <p className="method-name">کارتخوان</p>
          </label>
        </div> */}
      </div>
    </div>
  );
}

export default Order_payment_method;
